
import { useEffect, useState } from "react";
import { FaEdit, FaNewspaper } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { getSearchInfo } from '../../../shared/utils/storage';

const PaymentsInfo = () => {
  const [application, setApplication] = useState()

  useEffect(() => {
    const searchedData = getSearchInfo()
    if (searchedData) {
      setApplication(searchedData?.data)
    }
  }, [])
  //const data = useLocation().state
  const payments = application?.PaymentInfoData[0]
  const formattedDate = new Date(payments?.PaymentReceivedDate).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const styles = {
    h4: {
      color: '#850505',
      textTransform: 'uppercase',
    }
  };

  return (
    <>
      <table id="viewTable">
        <tr>
          <th colspan="3">
            <h4>
              <b>Travel Information</b>
            </h4>
          </th>
          <th style={{ textAlign: "right" }}>
            <b>
              <FaNewspaper style={{ fontSize: "23px" }} />
            </b>
          </th>
        </tr>
        <tr>
          <td>
            Jina La Mlipaji: <br />
            <h4 style={styles.h4}>
              {payments?.PayerName}
            </h4>
          </td>
          <td>
            Nambari ya Malipo: <br />
            <h4 style={styles.h4}>{payments?.PaymentControlNumber}</h4>
          </td>
          <td>
            Kiasi : <br />
            <h4 style={styles.h4}>{payments?.PaidAmount} {payments?.Currency}</h4>
          </td>
          <td>
            Tarehe Ya Malipo : <br />
            <h4 style={styles.h4}>{formattedDate}</h4>
          </td>
        </tr>
        <tr>
          <td>
            Njia Ya Malipo(Channel): <br />
            <h4 style={styles.h4}>
              {payments?.PaymentChannel}
            </h4>
          </td>
          <td>
            Nambari Ya Reisiti: <br />
            <h4 style={styles.h4}>{payments?.PaymentReceipt}</h4>
          </td>
          <td colSpan={2}>
            Nambari Ya Ombi : <br />
            <h4 style={styles.h4}>{payments?.ApplicationID}</h4>
          </td>
        </tr>
      </table>

      <br />


    </>
  );
}

export default PaymentsInfo;
